//import Vue from 'vue'

const state = {
	pagenum:1,
	category:'0',
	artists:'0',
}

const mutations = {
	'PAGE_MOVE'(state, val){
		state.pagenum = val
	},
	'CHANGE_CATEGORY'(state, val){
		state.category = val
	},
	'CHANGE_ARTISTS'(state, val){
		state.artists = val
	},
};

const actions = {
	set_page:({commit},val) => {
		commit('PAGE_MOVE',val)
	},
	slect_category:({commit},val) => {
		commit('CHANGE_CATEGORY',val)
	},
	select_artists:({commit},val) => {
		commit('CHANGE_ARTISTS',val)
	},
};

const getters = {
	get_pnum: state => {
		return state.pagenum
	},
	get_category: state => {
		return state.category
	},
	get_artists: state => {
		return state.artists
	}
};

export default {
	state,
	mutations,
	actions,
	getters,
}